import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import API_URL from "../config";
import { useCurrency } from "../context/CurrencyContext";   // ← add this

export default function Home() {
  const [featured, setFeatured] = useState([]);
  const [newItems, setNewItems] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const { format } = useCurrency();                         // ← add this

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [allRes, newRes] = await Promise.all([
          axios.get(`${API_URL}/api/products`),
          axios.get(`${API_URL}/api/products`)
        ]);
        setFeatured(allRes.data.slice(0, 4));
        setNewItems(newRes.data.filter(p => p.isNewArrival).slice(0, 4));
      } catch (err) {
        console.error("Home fetch error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400&family=DM+Sans:wght@300;400;500&display=swap');

        .hm-root *, .hm-root *::before, .hm-root *::after {
          box-sizing: border-box; margin: 0; padding: 0;
        }
        .hm-root {
          font-family: 'DM Sans', sans-serif;
          background: #fdf9f6;
          overflow-x: hidden;
          line-height: 1.5;
        }

        /* ── HERO ── */
        .hm-hero {
          position: relative;
          height: 52vh;
          min-height: 300px;
          max-height: 480px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          background: #fdf9f6;
        }
        .hm-hero-bg-word {
          position: absolute;
          top: 50%; left: 50%;
          transform: translate(-50%, -52%);
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(56px, 13vw, 160px);
          font-weight: 300;
          letter-spacing: 0.06em;
          color: transparent;
          -webkit-text-stroke: 1px rgba(200,112,144,0.10);
          white-space: nowrap;
          pointer-events: none;
          user-select: none;
          animation: hm-fade-in 1.4s ease forwards;
        }
        .hm-hero-deco-line {
          position: absolute;
          top: 0; left: 50%;
          width: 1px; height: 36px;
          background: linear-gradient(to bottom, transparent, #e8a0b0);
        }
        .hm-hero-content {
          position: relative;
          z-index: 2;
          text-align: center;
          padding: 0 20px;
          max-width: 520px;
          animation: hm-rise 0.9s 0.2s ease both;
        }
        .hm-eyebrow {
          font-size: 9px;
          font-weight: 500;
          letter-spacing: 0.26em;
          text-transform: uppercase;
          color: #c87090;
          margin-bottom: 10px;
          display: block;
        }
        .hm-hero-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(26px, 5vw, 50px);
          font-weight: 300;
          line-height: 1.1;
          color: #1a1410;
          letter-spacing: -0.01em;
          display: block;
          margin-bottom: 6px;
        }
        .hm-hero-title em { font-style: italic; color: #c87090; }
        .hm-hero-sub {
          font-size: 12px;
          font-weight: 300;
          color: #7a6e68;
          line-height: 1.7;
          margin: 8px 0 20px;
          display: block;
        }
        .hm-hero-cta {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: #1a1410;
          color: #fdf9f6;
          text-decoration: none;
          padding: 10px 24px;
          font-size: 10px;
          font-weight: 500;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          transition: background 0.25s;
        }
        .hm-hero-cta:hover { background: #c87090; }
        .hm-hero-arrow {
          width: 14px; height: 1px;
          background: currentColor;
          position: relative;
          display: inline-block;
          transition: width 0.25s;
        }
        .hm-hero-cta:hover .hm-hero-arrow { width: 20px; }
        .hm-hero-arrow::after {
          content: '';
          position: absolute;
          right: 0; top: -3px;
          width: 5px; height: 5px;
          border-right: 1.5px solid currentColor;
          border-top: 1.5px solid currentColor;
          transform: rotate(45deg);
        }
        .hm-hero-scroll {
          position: absolute;
          bottom: 14px; left: 50%;
          transform: translateX(-50%);
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 4px;
        }
        .hm-hero-scroll span {
          font-size: 8px;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          color: #ccc;
          display: block;
        }
        .hm-hero-scroll-line {
          width: 1px; height: 18px;
          background: linear-gradient(to bottom, #ccc, transparent);
          display: block;
          animation: hm-pulse-line 2s 1.5s ease-in-out infinite;
        }

        /* ── STRIP ── */
        .hm-strip { background: #1a1410; padding: 8px 0; overflow: hidden; }
        .hm-strip-track {
          display: flex;
          gap: 40px;
          animation: hm-marquee 22s linear infinite;
          white-space: nowrap;
          width: max-content;
        }
        .hm-strip-item {
          font-size: 9px;
          letter-spacing: 0.20em;
          text-transform: uppercase;
          color: rgba(253,249,246,0.5);
          display: inline-flex;
          align-items: center;
          gap: 10px;
        }
        .hm-strip-dot {
          width: 3px; height: 3px;
          border-radius: 50%;
          background: #c87090;
          flex-shrink: 0;
          display: inline-block;
        }

        /* ── SHARED SECTION ── */
        .hm-section {
          padding: 36px 28px;
          max-width: 1120px;
          margin: 0 auto;
        }
        @media (max-width: 768px) { .hm-section { padding: 24px 14px; } }

        .hm-section-label {
          font-size: 9px;
          font-weight: 500;
          letter-spacing: 0.26em;
          text-transform: uppercase;
          color: #c87090;
          margin-bottom: 5px;
          display: block;
        }
        .hm-section-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(18px, 3vw, 28px);
          font-weight: 300;
          color: #1a1410;
          margin: 0 0 20px;
          display: block;
          letter-spacing: -0.01em;
        }
        .hm-section-header {
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          margin-bottom: 20px;
          flex-wrap: wrap;
          gap: 8px;
        }
        .hm-section-header .hm-section-title { margin-bottom: 0; }
        .hm-view-all {
          font-size: 10px;
          font-weight: 500;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #a09890;
          text-decoration: none;
          border-bottom: 1px solid #ddd8d2;
          padding-bottom: 2px;
          transition: color 0.18s, border-color 0.18s;
          white-space: nowrap;
        }
        .hm-view-all:hover { color: #c87090; border-color: #c87090; }

        /* ── CATEGORIES ── */
        .hm-cats-grid {
          display: grid;
          grid-template-columns: 1.4fr 1fr 1fr;
          gap: 8px;
        }
        @media (max-width: 900px) {
          .hm-cats-grid { grid-template-columns: 1fr 1fr; gap: 8px; }
        }
        @media (max-width: 560px) {
          .hm-cats-grid { grid-template-columns: 1fr 1fr; gap: 6px; }
        }

        .hm-cat-card {
          position: relative;
          display: block;
          text-decoration: none;
          overflow: hidden;
          background: #f0ebe5;
          height: 120px;
        }
        .hm-cat-card:first-child { height: 140px; }

        @media (max-width: 900px) {
          .hm-cat-card:first-child { grid-column: 1 / -1; height: 110px; }
          .hm-cat-card { height: 100px; }
        }
        @media (max-width: 560px) {
          .hm-cat-card:first-child { grid-column: 1 / -1; height: 90px; }
          .hm-cat-card { height: 88px; }
        }

        .hm-cat-bg {
          position: absolute;
          inset: 0;
          transition: transform 0.55s cubic-bezier(0.25,0.46,0.45,0.94);
        }
        .hm-cat-card:hover .hm-cat-bg { transform: scale(1.04); }
        .hm-cat-women { background: linear-gradient(135deg,#f5dde4 0%,#e8b4c0 50%,#d4849a 100%); }
        .hm-cat-kids   { background: linear-gradient(135deg,#fde8cc 0%,#f5c994 50%,#e8a55a 100%); }
        .hm-cat-cosm   { background: linear-gradient(135deg,#e4daf5 0%,#c9b4e8 50%,#a884d4 100%); }
        .hm-cat-pat {
          position: absolute;
          inset: 0;
          opacity: 0.07;
          background-image:
            radial-gradient(circle at 25% 25%, white 1px, transparent 1px),
            radial-gradient(circle at 75% 75%, white 1px, transparent 1px);
          background-size: 22px 22px;
        }
        .hm-cat-info {
          position: absolute;
          bottom: 0; left: 0; right: 0;
          padding: 12px 14px;
          background: linear-gradient(to top, rgba(20,14,10,0.68) 0%, transparent 100%);
        }
        .hm-cat-sub {
          font-size: 8px;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          color: rgba(255,255,255,0.55);
          display: block;
          margin-bottom: 1px;
        }
        .hm-cat-name {
          font-family: 'Cormorant Garamond', serif;
          font-size: 17px;
          font-weight: 400;
          color: white;
          display: block;
          margin-bottom: 1px;
          line-height: 1.1;
        }
        .hm-cat-desc {
          font-size: 10px;
          font-weight: 300;
          color: rgba(255,255,255,0.60);
          display: block;
        }
        @media (max-width: 560px) {
          .hm-cat-name { font-size: 14px; }
          .hm-cat-desc { display: none; }
          .hm-cat-info { padding: 8px 10px; }
        }
        .hm-cat-arrow {
          position: absolute;
          top: 10px; right: 10px;
          width: 22px; height: 22px;
          border: 1px solid rgba(255,255,255,0.25);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          opacity: 0;
          transform: translateY(4px);
          transition: opacity 0.28s, transform 0.28s;
        }
        .hm-cat-card:hover .hm-cat-arrow { opacity: 1; transform: translateY(0); }

        /* ── PRODUCT GRID ── */
        .hm-prod-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 10px;
        }
        @media (max-width: 900px) { .hm-prod-grid { grid-template-columns: repeat(2, 1fr); gap: 8px; } }
        @media (max-width: 480px) { .hm-prod-grid { grid-template-columns: repeat(2, 1fr); gap: 6px; } }

        /* New arrivals cards */
        .hm-prod-card {
          background: #fff;
          border: 1px solid #ede8e2;
          overflow: hidden;
          text-decoration: none;
          display: block;
          transition: transform 0.26s, box-shadow 0.26s;
        }
        .hm-prod-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(0,0,0,0.07);
        }
        .hm-prod-img-wrap {
          position: relative;
          background: #f4efe9;
          overflow: hidden;
          height: 150px;
        }
        .hm-prod-img {
          width: 100%; height: 100%;
          object-fit: cover;
          display: block;
          transition: transform 0.45s ease;
        }
        .hm-prod-card:hover .hm-prod-img { transform: scale(1.04); }
        .hm-prod-new-badge {
          position: absolute;
          top: 7px; left: 7px;
          background: #c87090;
          color: white;
          font-size: 7.5px;
          font-weight: 600;
          letter-spacing: 0.13em;
          text-transform: uppercase;
          padding: 2px 6px;
        }
        .hm-prod-body { padding: 8px 10px 10px; }
        .hm-prod-cat {
          font-size: 8px;
          font-weight: 500;
          letter-spacing: 0.15em;
          text-transform: uppercase;
          color: #c87090;
          margin-bottom: 2px;
          display: block;
        }
        .hm-prod-name {
          font-family: 'Cormorant Garamond', serif;
          font-size: 14px;
          font-weight: 400;
          color: #1a1410;
          display: block;
          margin-bottom: 2px;
          line-height: 1.2;
        }
        /* ✅ Price now auto-formatted — no hardcoded PKR */
        .hm-prod-price {
          font-size: 11px;
          font-weight: 500;
          color: #c87090;
          display: block;
        }

        /* ── PLACEHOLDER ── */
        .hm-placeholder-card {
          background: #241e19;
          border: 1px solid rgba(255,255,255,0.06);
          overflow: hidden;
        }
        .hm-ph-img {
          height: 150px;
          background: #2e2620;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 6px;
          position: relative;
        }
        .hm-ph-img::before {
          content: '';
          position: absolute;
          inset: 0;
          background: radial-gradient(ellipse at 50% 0%, rgba(200,112,144,0.07), transparent 65%);
        }
        .hm-ph-bar  { width: 16px; height: 1px; background: rgba(200,112,144,0.35); display: block; }
        .hm-ph-line { width: 1px; height: 18px; background: rgba(200,112,144,0.35); display: block; }
        .hm-ph-text {
          font-family: 'Cormorant Garamond', serif;
          font-size: 10px;
          font-style: italic;
          color: rgba(253,249,246,0.22);
          margin-top: 3px;
          display: block;
        }
        .hm-ph-body {
          padding: 8px 10px;
          border-top: 1px solid rgba(255,255,255,0.05);
        }
        .hm-ph-tag {
          font-size: 8px;
          letter-spacing: 0.13em;
          text-transform: uppercase;
          color: rgba(253,249,246,0.22);
          margin-bottom: 3px;
          display: block;
        }
        .hm-ph-name {
          font-family: 'Cormorant Garamond', serif;
          font-size: 14px;
          font-weight: 400;
          color: rgba(253,249,246,0.45);
          font-style: italic;
          display: block;
        }

        /* ── FEATURED DARK SECTION ── */
        .hm-feat-section {
          background: #1a1410;
          padding: 36px 28px;
        }
        @media (max-width: 768px) { .hm-feat-section { padding: 24px 14px; } }
        .hm-feat-inner { max-width: 1120px; margin: 0 auto; }
        .hm-feat-label {
          font-size: 9px;
          font-weight: 500;
          letter-spacing: 0.26em;
          text-transform: uppercase;
          color: #c87090;
          margin-bottom: 5px;
          display: block;
        }
        .hm-feat-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(18px, 3vw, 28px);
          font-weight: 300;
          color: #fdf9f6;
          display: block;
          letter-spacing: -0.01em;
        }
        .hm-feat-header {
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          margin-bottom: 20px;
          flex-wrap: wrap;
          gap: 8px;
        }
        .hm-feat-view-all {
          font-size: 10px;
          font-weight: 500;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: rgba(253,249,246,0.38);
          text-decoration: none;
          border-bottom: 1px solid rgba(253,249,246,0.16);
          padding-bottom: 2px;
          transition: color 0.18s, border-color 0.18s;
          white-space: nowrap;
        }
        .hm-feat-view-all:hover { color: #c87090; border-color: #c87090; }

        .hm-feat-prod-card {
          background: #241e19;
          border: 1px solid rgba(255,255,255,0.06);
          overflow: hidden;
          text-decoration: none;
          display: block;
          transition: transform 0.26s, border-color 0.26s;
        }
        .hm-feat-prod-card:hover {
          transform: translateY(-2px);
          border-color: rgba(200,112,144,0.25);
        }
        .hm-feat-prod-img-wrap {
          position: relative;
          background: #2e2620;
          overflow: hidden;
          height: 150px;
        }
        .hm-feat-prod-img {
          width: 100%; height: 100%;
          object-fit: cover;
          display: block;
          transition: transform 0.45s ease;
          opacity: 0.92;
        }
        .hm-feat-prod-card:hover .hm-feat-prod-img { transform: scale(1.04); opacity: 1; }
        .hm-feat-prod-body {
          padding: 8px 10px;
          border-top: 1px solid rgba(255,255,255,0.05);
        }
        .hm-feat-prod-cat {
          font-size: 8px;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: rgba(200,112,144,0.65);
          margin-bottom: 2px;
          display: block;
        }
        .hm-feat-prod-name {
          font-family: 'Cormorant Garamond', serif;
          font-size: 14px;
          font-weight: 400;
          color: rgba(253,249,246,0.75);
          font-style: italic;
          display: block;
          margin-bottom: 2px;
        }
        /* ✅ Price now auto-formatted — no hardcoded PKR */
        .hm-feat-prod-price {
          font-size: 11px;
          font-weight: 500;
          color: rgba(253,249,246,0.55);
          display: block;
        }

        /* ── BRAND ── */
        .hm-brand {
          position: relative;
          padding: 52px 28px;
          text-align: center;
          background: #fdf9f6;
          overflow: hidden;
        }
        @media (max-width: 768px) { .hm-brand { padding: 40px 14px; } }
        .hm-brand-circle {
          position: absolute;
          border-radius: 50%;
          border: 1px solid rgba(200,112,144,0.07);
          top: 50%; left: 50%;
          transform: translate(-50%,-50%);
          pointer-events: none;
        }
        .hm-brand-content { position: relative; z-index: 2; }
        .hm-brand-name {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(30px, 6vw, 64px);
          font-weight: 300;
          color: #1a1410;
          line-height: 1;
          letter-spacing: 0.04em;
          display: block;
        }
        .hm-brand-name span {
          display: block;
          font-style: italic;
          color: #c87090;
          font-size: 0.5em;
          letter-spacing: 0.12em;
          margin-top: 4px;
        }
        .hm-brand-div {
          width: 36px; height: 1px;
          background: linear-gradient(to right, transparent, #c87090, transparent);
          margin: 16px auto;
          display: block;
        }
        .hm-brand-desc {
          font-size: 12px;
          font-weight: 300;
          color: #7a6e68;
          max-width: 380px;
          margin: 0 auto;
          line-height: 1.8;
          display: block;
        }

        /* ── ANIMATIONS ── */
        @keyframes hm-fade-in { from{opacity:0} to{opacity:1} }
        @keyframes hm-rise {
          from{opacity:0;transform:translateY(14px)}
          to{opacity:1;transform:translateY(0)}
        }
        @keyframes hm-pulse-line {
          0%,100%{opacity:0.35;transform:scaleY(1)}
          50%{opacity:1;transform:scaleY(1.3)}
        }
        @keyframes hm-marquee {
          from{transform:translateX(0)}
          to{transform:translateX(-50%)}
        }
      `}</style>

      <div className="hm-root">

        {/* HERO */}
        <section className="hm-hero">
          <div className="hm-hero-deco-line" />
          <div className="hm-hero-bg-word">STMZ</div>
          <div className="hm-hero-content">
            <span className="hm-eyebrow">New Collection · 2025</span>
            <span className="hm-hero-title">
              Luxury Fashion<br/>for <em>Women &amp; Kids</em>
            </span>
            <span className="hm-hero-sub">
              Discover premium styles, modern trends,<br/>and elegant outfits for every occasion.
            </span>
            <a href="/products" className="hm-hero-cta">
              Shop the Collection
              <span className="hm-hero-arrow" />
            </a>
          </div>
          <div className="hm-hero-scroll">
            <span>Scroll</span>
            <span className="hm-hero-scroll-line" />
          </div>
        </section>

        {/* MARQUEE STRIP */}
        <div className="hm-strip">
          <div className="hm-strip-track">
            {["Premium Quality","Women's Fashion","Kids' Collection","Luxury Cosmetics",
              "New Arrivals Weekly","Free Delivery on Orders",
              "Premium Quality","Women's Fashion","Kids' Collection","Luxury Cosmetics",
              "New Arrivals Weekly","Free Delivery on Orders"
            ].map((t, i) => (
              <span className="hm-strip-item" key={i}>
                <span className="hm-strip-dot" />{t}
              </span>
            ))}
          </div>
        </div>

        {/* CATEGORIES */}
        <section className="hm-section">
          <span className="hm-section-label">Shop by Category</span>
          <span className="hm-section-title">Find Your Style</span>
          <div className="hm-cats-grid">

            <a href="/products?category=women" className="hm-cat-card">
              <div className="hm-cat-bg hm-cat-women"
                style={{
                  backgroundImage: "url('https://res.cloudinary.com/dunj9ufzp/image/upload/v1776432514/woman_avjqyd.jpg')",
                  backgroundSize: "cover",
                  backgroundPosition: "center"
                }}
              />
              <div className="hm-cat-pat" />
              <div className="hm-cat-info">
                <span className="hm-cat-sub">Collection 2025</span>
                <span className="hm-cat-name">Women</span>
                <span className="hm-cat-desc">Explore the latest fashion</span>
              </div>
              <div className="hm-cat-arrow">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
              </div>
            </a>

            <a href="/products?category=kids" className="hm-cat-card">
              <div className="hm-cat-bg hm-cat-kids"
                style={{
                  backgroundImage: "url('https://res.cloudinary.com/dunj9ufzp/image/upload/v1776432537/kid_uos0dc.jpg')",
                  backgroundSize: "cover",
                  backgroundPosition: "center"
                }}
              />
              <div className="hm-cat-pat" />
              <div className="hm-cat-info">
                <span className="hm-cat-sub">Little Ones</span>
                <span className="hm-cat-name">Kids</span>
                <span className="hm-cat-desc">Cute &amp; comfy styles</span>
              </div>
              <div className="hm-cat-arrow">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
              </div>
            </a>

            <a href="/products?category=cosmetics" className="hm-cat-card">
              <div className="hm-cat-bg hm-cat-cosm"
                style={{
                  backgroundImage: "url('https://res.cloudinary.com/dunj9ufzp/image/upload/v1776432562/cosmetics_y2yjsc.jpg')",
                  backgroundSize: "cover",
                  backgroundPosition: "center"
                }}
              />
              <div className="hm-cat-pat" />
              <div className="hm-cat-info">
                <span className="hm-cat-sub">Beauty Edit</span>
                <span className="hm-cat-name">Cosmetics</span>
                <span className="hm-cat-desc">Beauty essentials</span>
              </div>
              <div className="hm-cat-arrow">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
              </div>
            </a>

          </div>
        </section>

        {/* NEW ARRIVALS */}
        {newItems.length > 0 && (
          <section className="hm-section" style={{paddingTop:0}}>
            <div className="hm-section-header">
              <div>
                <span className="hm-section-label">Just Landed</span>
                <span className="hm-section-title" style={{marginBottom:0}}>New Arrivals</span>
              </div>
              <Link to="/new-arrivals" className="hm-view-all">View All →</Link>
            </div>
            <div className="hm-prod-grid">
              {newItems.map(p => (
                <Link to={`/product/${p._id}`} key={p._id} className="hm-prod-card">
                  <div className="hm-prod-img-wrap">
                    <img src={p.image} alt={p.name} className="hm-prod-img" />
                    <span className="hm-prod-new-badge">New</span>
                  </div>
                  <div className="hm-prod-body">
                    <span className="hm-prod-cat">{p.category}</span>
                    <span className="hm-prod-name">{p.name}</span>
                    {/* ✅ FIXED: was `{p.price} <span>PKR</span>` */}
                    <span className="hm-prod-price">{format(p.price)}</span>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        )}

        {/* FEATURED PRODUCTS */}
        <section className="hm-feat-section">
          <div className="hm-feat-inner">
            <div className="hm-feat-header">
              <div>
                <span className="hm-feat-label">Curated Picks</span>
                <span className="hm-feat-title">Featured Products</span>
              </div>
              <Link to="/products" className="hm-feat-view-all">View All →</Link>
            </div>
            <div className="hm-prod-grid">
              {loading ? (
                ["Women's Wear","Kids' Style","Cosmetics","Accessories"].map((label, i) => (
                  <div className="hm-placeholder-card" key={i}>
                    <div className="hm-ph-img">
                      <span className="hm-ph-bar" />
                      <span className="hm-ph-line" />
                      <span className="hm-ph-text">Loading…</span>
                    </div>
                    <div className="hm-ph-body">
                      <span className="hm-ph-tag">{label}</span>
                      <span className="hm-ph-name">Coming soon</span>
                    </div>
                  </div>
                ))
              ) : featured.length > 0 ? (
                featured.map(p => (
                  <Link to={`/product/${p._id}`} key={p._id} className="hm-feat-prod-card">
                    <div className="hm-feat-prod-img-wrap">
                      <img src={p.image} alt={p.name} className="hm-feat-prod-img" />
                    </div>
                    <div className="hm-feat-prod-body">
                      <span className="hm-feat-prod-cat">{p.category}</span>
                      <span className="hm-feat-prod-name">{p.name}</span>
                      {/* ✅ FIXED: was `{p.price} PKR` */}
                      <span className="hm-feat-prod-price">{format(p.price)}</span>
                    </div>
                  </Link>
                ))
              ) : (
                ["Women's Wear","Kids' Style","Cosmetics","Accessories"].map((label, i) => (
                  <div className="hm-placeholder-card" key={i}>
                    <div className="hm-ph-img">
                      <span className="hm-ph-bar" />
                      <span className="hm-ph-line" />
                      <span className="hm-ph-text">Coming soon</span>
                    </div>
                    <div className="hm-ph-body">
                      <span className="hm-ph-tag">{label}</span>
                      <span className="hm-ph-name">New Arrival</span>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </section>

        {/* BRAND */}
        <section className="hm-brand">
          {[200,340,480].map(s => (
            <div key={s} className="hm-brand-circle" style={{width:s,height:s}} />
          ))}
          <div className="hm-brand-content">
            <span className="hm-eyebrow">Our Story</span>
            <span className="hm-brand-name">STMZ<span>Group</span></span>
            <span className="hm-brand-div" />
            <span className="hm-brand-desc">
              Premium fashion brand for women &amp; kids.<br/>
              Designed with elegance, comfort, and modern trends.
            </span>
          </div>
        </section>

      </div>
    </>
  );
}